<template>
    <div class="layout-container">
        <el-tabs type="border-card"  v-model="activeName"  @tab-click="handleClick">
             <el-tab-pane label="表单" name="表单">
                 <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con show">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-if="activeName == '表单'" v-model="formCondition.site_id" :owned='true' :clueId=1 :init-choose-first="false" ref="siteAutoCompleteForm" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition applyEntry">
                            <span class="label">来源终端</span>
                            <div class="input-condition">
                                <el-select v-model="formCondition.terminal_id" placeholder="请选择" @change="changeTerminal1">
                                    <el-option v-for="item in terminals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                                <el-select v-model="formCondition.extendId" placeholder="请选择" v-if="formCondition.terminal_id == 3 || formCondition.terminal_id == 4">
                                    <el-option v-for="item in terminalExtend" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition applyEntry">
                            <span class="label">报名入口</span>
                            <div class="input-condition">
                                <el-select v-model="formCondition.form_page" @change="getPosition">
                                    <el-option
                                        v-for="(item, key) in pages"
                                        :value="item.form_page"
                                        :label="item.form_page"
                                        :key="key"
                                    ></el-option>
                                </el-select>
                                <el-select v-if="positions.length>1" v-model="formCondition.form_id">
                                    <el-option
                                        v-for="(item, key) in positions"
                                        :value="item.id"
                                        :label="item.name"
                                        :key="key"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="formCheckDate('month')" :class="formCondition.timeStamp == 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="formCheckDate('doubleMonth')" :class="formCondition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="formCondition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="formCondition.timeStamp = ''"
                                    :picker-options="pickerOptions"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch1()">查 询</el-button>
                        <el-button  @click="resetSearch(1)">清空条件</el-button>
                        <el-button-group class="floatR" style="margin-left:20px;">
                            <el-tooltip class="item" effect="dark" content="导出" placement="top">
                                <el-button icon="el-icon-download" @click="downloadForm"></el-button>
                            </el-tooltip>
                        </el-button-group>  
                    </div>
                </div>
                <div class="totalData" v-if="formTotal">
                    <div class="item">
                        <p><span>{{formTotal.no_distinct_total}}</span><span>(去重：{{formTotal.distinct_total}})</span></p>
                        <label>合计线索量</label>
                    </div>
                </div>
                <el-table
                        :data="formDataList"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable1"
                        v-loading="isLoading"
                        @sort-change="formSortChange"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="站点" prop="site_name"></el-table-column>
                    <el-table-column label="终端" prop="terminal_name"></el-table-column>
                    <el-table-column label="页面名称" prop="form_page"></el-table-column>
                    <el-table-column label="表单名称" prop="form_name"></el-table-column>
                    <el-table-column label="线索量" prop="no_distinct_total" sortable="custom">
                        <template scope="scope" >
                            <span>{{scope.row.no_distinct_total}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="线索量(去重)" prop="distinct_total">
                        <template scope="scope" >
                            <span>{{scope.row.distinct_total}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="formDataList.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="formCondition.page"  :total="formListNum" :page-size="formCondition.per_page" @current-change="formCurrentChange"></el-pagination>
                </template>
            </el-tab-pane>
             <el-tab-pane label="IM" name="IM">
                 <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con show">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-if="activeName == 'IM'" v-model="IMCondition.site_id" :owned='true' :clueId=1 ref="siteAutoCompleteIM" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition applyEntry">
                            <span class="label">来源终端</span>
                            <div class="input-condition">
                                <el-select v-model="IMCondition.terminal_id" placeholder="请选择" @change="changeTerminal1">
                                    <el-option v-for="item in terminals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                                <el-select v-model="IMCondition.extendId" placeholder="请选择" v-if="IMCondition.terminal_id == 3 || IMCondition.terminal_id == 4" @change="changeTerminal2">
                                    <el-option v-for="item in terminalExtend" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition applyEntry">
                            <span class="label">咨询入口</span>
                            <div class="input-condition">
                                 <el-select v-model="IMCondition.form_page" @change="getPosition">
                                    <el-option
                                        v-for="(item, key) in pages"
                                        :value="item.form_page"
                                        :label="item.form_page"
                                        :key="key"
                                    ></el-option>
                                </el-select>
                                <el-select v-if="positions.length>1" v-model="IMCondition.form_id">
                                    <el-option
                                        v-for="(item, key) in positions"
                                        :value="item.id"
                                        :label="item.name"
                                        :key="key"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">获取方式</span>
                            <div class="input-condition">
                                <el-select v-model="IMCondition.source_id">
                                <el-option
                                    v-for="(item, key) in imType"
                                    :value="item.id"
                                    :label="item.name"
                                    :key="key"
                                ></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="IMCheckDate('month')" :class="IMCondition.timeStamp == 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="IMCheckDate('doubleMonth')" :class="IMCondition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="IMCondition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="IMCondition.timeStamp = ''"
                                    :picker-options="pickerOptions"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch2()">查 询</el-button>
                        <el-button  @click="resetSearch(2)">清空条件</el-button>
                        <el-button-group class="floatR" style="margin-left:20px;">
                            <el-tooltip class="item" effect="dark" content="导出" placement="top">
                                <el-button icon="el-icon-download" @click="downloadIM"></el-button>
                            </el-tooltip>
                        </el-button-group>  
                    </div>
                </div>
                <div class="totalData" v-if="IMTotal">
                    <div class="item">
                        <p><span>{{IMTotal.conversations}}</span><span>(去重：{{IMTotal.customers}})</span></p>
                        <label>合计咨询人数</label>
                    </div>
                     <div class="item">
                        <p><span>{{IMTotal.no_distinct_total}}</span><span>(去重：{{IMTotal.distinct_total}})</span></p>
                        <label>合计线索量</label>
                    </div>
                    <!-- <div class="item">
                        <p>{{IMTotal.rate}}%</p>
                        <label>获客率</label>
                    </div> -->
                </div>
                <el-table
                        :data="IMDataList"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable2"
                        v-loading="isLoading"
                        @sort-change="IMSortChange"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="站点" prop="site_name"></el-table-column>
                    <el-table-column label="终端" prop="terminal_name"></el-table-column>
                    <el-table-column label="页面名称" prop="form_page"></el-table-column>
                    <el-table-column label="咨询入口" prop="form_name"></el-table-column>
                    <el-table-column label="咨询人数" prop="people_num" sortable="custom">
                        <template scope="scope" >
                            <span>{{scope.row.people_num}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="咨询人数(去重)" prop="distinct_people_num">
                        <template scope="scope" >
                            <span>{{scope.row.distinct_people_num}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="线索量" prop="no_distinct_total" sortable="custom">
                        <template scope="scope" >
                            <span>{{scope.row.no_distinct_total}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="线索量(去重)" prop="distinct_total">
                        <template scope="scope" >
                            <span>{{scope.row.distinct_total}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="获客率" prop="rate" sortable="custom">
                         <template scope="scope" >
                            <span>{{scope.row.rate}}%</span>
                        </template>
                    </el-table-column> -->
                </el-table>
                <template v-if="IMDataList.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="IMCondition.page"  :total="IMListNum" :page-size="IMCondition.per_page" @current-change="IMCurrentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>

    import { parseTime } from '@/utils'
    import { getTerminalsNew , getPositionInfo ,getCustomerForm ,getCustomerIM} from '@/service/customer'
    import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";

    export default {
        name: "List",
        components: {
            SiteAutoComplete,
        },

        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                activeName:'表单',//当前Tab名称
                isLoading: true,
                formCondition:{ //表单
                    site_id: 0,
                    time: null,
                    timeStamp: 'month',
                    terminal_id:0,
                    extendId:null,
                    form_page:"全部",
                    form_id:0,
                    page :1,
                    per_page : 10,
                    type:1,
                },
                lastFormCondition:null,
                formListNum:0,
                formTotal:null,
                formDataList:[],
                terminals:[ //公共
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                terminalExtend:[
                    {
                        id :null,
                        name : '全部'
                    }
                ],
                pages:[
                    {form_page:"全部"}
                ],
                positions:[
                    {
                        id: 0, 
                        name: "全部"
                    }
                ],


                IMCondition:{ //IM
                    site_id: 0,
                    time: '',
                    timeStamp: 'month',
                    terminal_id:0,
                    extendId:null,
                    form_page:"全部",
                    form_id:0,
                    source_id:0,
                    page :1,
                    per_page : 10,
                    type:2
                },
                imType:[
                     {
                        id : 0,
                        name : '全部'
                    },
                     {
                        id : 4,
                        name : 'IM用户授权'
                    },
                     {
                        id :5,
                        name : 'IM主动预留'
                    }
                ],
                lastIMCondition:null,
                IMListNum:0,
                IMTotal:null,
                IMDataList:[],
            }
        },
        mounted () {
             getTerminalsNew({}).then((data) => {
                this.terminals = this.terminals.concat(data)
            })
            this.getPages()
            this.initDataForm();
        },
        methods: {
            handleClick(tab, event) { //tab切换
            this.isLoading=true
              if(this.activeName == "表单"){
                    this.getPages()
                    this.resetIm()
                    this.initDataForm()
              }else{
                    this.getPages()
                    this.resetForm()
                    this.initDataIM()
              }
            },
            resetSearch(type){
                if(type == 1){
                    this.resetForm();
                    this.$nextTick(() => {
                        this.$refs.siteAutoCompleteForm && this.$refs.siteAutoCompleteForm.reset();
                    })
                    this.initDataForm()
                }
                if(type == 2){
                    this.resetIm()
                    this.$nextTick(() => {
                        this.$refs.siteAutoCompleteIM && this.$refs.siteAutoCompleteIM.reset();
                    })
                    this.initDataIM()
                }
            },
            resetForm(){
                this.formCondition={
                        site_id: 0,
                        time: '',
                        timeStamp: 'month',
                        terminal_id:0,
                        extendId:null,
                        form_page:"全部",
                        form_id:0,
                        page :1,
                        per_page : 10,
                        type:1,
                    }
                    this.$refs.multipleTable1.columns.forEach(item => {
                        item.order = ''
                    })
                    this.terminalExtend=[
                        {
                            id :null,
                            name : '全部'
                        }
                    ]
                    this.positions=[{
                        id: 0, 
                        name: "全部"
                    }]
            },
            resetIm(){
                this.IMCondition={
                        site_id: 0,
                        time: '',
                        timeStamp: 'month',
                        terminal_id:0,
                        extendId:null,
                        form_page:"全部",
                        form_id:0,
                        source_id:0,
                        page :1,
                        per_page : 10,
                        type:2
                    }
                    this.$refs.multipleTable2.columns.forEach(item => {
                        item.order = ''
                    })
                    this.terminalExtend=[
                        {
                            id :null,
                            name : '全部'
                        }
                    ]
                    this.positions=[{
                        id: 0, 
                        name: "全部"
                    }]
            },
            exportPathMethod(data,query) { //导出
	            /*
	            *注：csv文件：","逗号换列，\n换行，\t防止excel将长数字变科学计算法等样式
	            */
	            //要导出的json数据
	            let mainLists = data.trade   //主表
	            let _self = this
	            //## 数据处理
	            //一级表
	            let mainTitle = mainLists.tHeader;//一级标题
	            let mainTitleForKey = mainLists.filterVal;//一级过滤
	            let mainList = mainLists.list;//一级数据
	            let mainStr = [];
	            mainStr.push(mainTitle.join("\t,")+"\n");   //标题添加上换列转成字符串并存进数组
	            for(let i=0;i<mainList.length;i++){
	                let temp = [];
	                for(let j=0;j<mainTitleForKey.length;j++){
	                    temp.push(mainList[i][mainTitleForKey[j]]); //根据过滤器拿出对应的值
	                }
	                mainStr.push(temp.join("\t,")+"\n");    //取出来的值加上逗号换列转字符串存数组
	            }	
	            //两个表数组转成字符串合并
	            let merged = mainStr.join("")	            
	            //## 导出操作
	            // encodeURIComponent解决中文乱码
	            const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(merged)
	            // 通过创建a标签实现
	            let link = document.createElement('a')
	            link.href = uri
                let name = '报名入口（'+this.activeName+'）';
                let timeStart=''
                let timeEnd=''
                timeStart =parseTime(query.start_time,'{y}-{m}-{d}')
                timeEnd = parseTime(query.end_time,'{y}-{m}-{d}')
                name += timeStart+'至'+timeEnd
	            // 对下载的文件命名
                link.download = name+'.csv'
	            document.body.appendChild(link)
	            link.click()
	        },
             //终端
            changeTerminal1(val){
                this.formCondition.extendId=null;
                this.IMCondition.extendId=null;
                this.terminalExtend=[
                     {
                        id :0,
                        name : '全部'
                    }
                ]
                if(val == 3 || val ==4 ){
                    let obj =this.terminals.filter(item => item.id === val)
                    this.terminalExtend =this.terminalExtend.concat(obj[0].expend)
                }
            },
            getPages(){
                this.pages=[{form_page:"全部"}]
                let query={};
                if(this.activeName=='表单'){
                    query.type=1;
                }
                if(this.activeName=='IM'){
                    query.type=2;
                }
                  getPositionInfo(0,query).then((data) => {
                   this.pages=this.pages.concat(data);
                })
            },
         
            getPosition(val){
               if(val == "全部"){
                    this.positions=[
                        {
                            id: 0, 
                            name: "全部"
                        }
                    ]
                    this.formCondition.form_id=0;
                    this.IMCondition.form_id=0;
                   return
               }
                this.formCondition.form_id=0;
                this.IMCondition.form_id=0;
                this.positions=[
                    {
                        id: 0, 
                        name: "全部"
                    }
                ]
                let obj =this.pages.filter(item => item.form_page == val)
                this.positions=this.positions.concat(obj[0].form_name_arr);
               
            },
            //表单
            formCheckDate (value) {
                this.formCondition = Object.assign({}, this.formCondition, {
                    timeStamp: value,
                    time: ''
                })
            },
            formSortChange(column){
                let order ='';
                if(column.order == 'descending'){
                    order='desc'
                }else{
                    order='asc'
                }
                if(!this.formCondition.site_id){
                    this.formCondition.site_id=0
                }
                this.formCondition.page=1
                this.formCondition.sort_name =column.prop
                this.formCondition.sort_order =order

                this.initDataForm();
            },
            handleSearch1() {
                this.formCondition.page = 1
                this.initDataForm()
            },
            async initDataForm() {
                this.isLoading = true
                let query =JSON.parse(JSON.stringify(this.formCondition))
                if (this.formCondition.timeStamp.length > 0) {
                    let time_quantum = this.formCondition.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                } else if(this.formCondition.time && this.formCondition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.formCondition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.formCondition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }
                if(!query.site_id){
                    query.site_id=0
                }
                if(this.formCondition.extendId>0){
                    query.terminal_id=this.formCondition.extendId;
                }
                this.lastFormCondition=JSON.parse(JSON.stringify(query))
                await getCustomerForm(query).then((data) => {
                    if(data.data.length){
                        this.formDataList=data.data;
                    }else{
                        this.formDataList=[]
                       
                    }
                    this.formTotal=data.data_statistics;
                    this.formListNum=data.total
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
                /* 数据请求完毕取消当前页面的loading */
                this.isLoading = false;
            },
           async downloadForm(){
                const _self=this
                if(!_self.formDataList.length){
                    _self.$message({
                        message: "请先查询需要导出的数据",
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return 
                }
                let query =_self.lastFormCondition;
                query.per_page=999;
                query.page=1
                await getCustomerForm(query).then((data) => {
                    // data.data.forEach(el => {
                    //     el.total_str=el.no_distinct_total+'（去重：'+el.distinct_total+'）'
                    // });
                    let jsonData = {
                        trade:{
                            tHeader: ["站点","终端","页面名称","表单名称","线索量","线索量(去重)"],
                            filterVal: ["site_name","terminal_name","form_page","form_name","no_distinct_total","distinct_total"],
                            list: data.data
                        }
                    }    
                    _self.exportPathMethod(jsonData,query)// 调用exportPathMethod对数据进行处理导出
                    _self.exportShow=false
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
            },
            formCurrentChange (index) {
                this.formCondition.page = index
                this.initDataForm()
            },


            //IM
            handleSearch2() {
                this.IMCondition.page = 1
                this.initDataIM()
            },
            async initDataIM(){
                this.isLoading = true
                let query =JSON.parse(JSON.stringify(this.IMCondition))
                if (this.IMCondition.timeStamp.length > 0) {
                    let time_quantum = this.IMCondition.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                } else if(this.IMCondition.time && this.IMCondition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.IMCondition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.IMCondition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }
                if(!query.site_id){
                    query.site_id=0
                }
                if(this.IMCondition.extendId>0){
                    query.terminal_id=this.IMCondition.extendId;
                }
                this.lastIMCondition=JSON.parse(JSON.stringify(query))
                await getCustomerForm(query).then((data) => {
                    if(data.data.length){
                        this.IMDataList=data.data;
                    }else{
                        this.IMDataList=[]
                       
                    }
                    this.IMTotal=data.data_statistics;
                    this.IMListNum=data.total
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
                /* 数据请求完毕取消当前页面的loading */
                this.isLoading = false;
            },
            IMSortChange(column){
                let order ='';
                if(column.order == 'descending'){
                    order='desc'
                }else{
                    order='asc'
                }
                if(!this.formCondition.site_id){
                    this.formCondition.site_id=0
                }
                this.IMCondition.page=1
                this.IMCondition.sort_name =column.prop
                this.IMCondition.sort_order =order

                this.initDataIM();
            },
            IMCheckDate (value) {
                this.IMCondition = Object.assign({}, this.IMCondition, {
                    timeStamp: value,
                    time: ''
                })
            },
            IMCurrentChange(index){
                this.IMCondition.page = index
                this.initDataIM()
            },
            async downloadIM(){
                 const _self=this
                if(!_self.IMDataList.length){
                    _self.$message({
                        message: "请先查询需要导出的数据",
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return 
                }
                let query =_self.lastIMCondition;
                query.per_page=999;
                query.page=1
                await getCustomerForm(query).then((data) => {
                    // data.data.forEach(el => {
                    //     // el.total_str=el.no_distinct_total+'（去重：'+el.distinct_total+'）';
                    //     // el.people_str=el.people_num+'（去重：'+el.distinct_people_num+'）'
                    //     el.rate_str=el.rate+'%'
                    // });
                    let jsonData = {
                        trade:{
                            tHeader: ["站点","终端","页面名称","咨询入口","咨询人数","咨询人数(去重)","线索量","线索量(去重)"],
                            filterVal: ["site_name","terminal_name","form_page","form_name","people_num","distinct_people_num","no_distinct_total","distinct_people_num"],
                            list: data.data
                        }
                    }    
                    _self.exportPathMethod(jsonData,query)// 调用exportPathMethod对数据进行处理导出
                    _self.exportShow=false
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
            },
        }
    }
</script>

<style scoped>
    .totalData{
        height: 100px;
        margin: 30px 40px 0;
    }
    .totalData .item{
        width: 15%;
        float: left;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
    }
    .applyEntry{
        width: 28%;
        max-width: 500px;
    }
    .applyEntry .el-select{
        width: 40%;
        float: left;
        margin-right: 10px;
    }
    
</style>
